export default {
  BusinessPurchaseOrderDetail: {
    status: 'Purchase Order Status',
    operationLog: 'Operation Log',
    storageStatus: 'Storage Status',
    planQty: 'Purchase Quantity',
    alreadyQty: 'Received',
    waitQty: 'Unreceived',
    cancelQty: 'Stop waiting',
    poInformation: 'Purchase Order Account Information',
    code: 'Purchase Order No.',
    typeMeaning: 'Purchase Type',
    supplierName: 'Supplier',
    warehouseName: 'Receiving Warehouse',
    auditTime: 'Review Time',
    finishTime: 'Completion Time',
    buyerName: 'Purchaser',
    paymentType: 'Payment Method',
    invoiceTypeMeaning: 'Invoice Type',
    packagingFlag: 'Whether it contains packaging',
    shippingFlag: 'Whether free shipping',
    overfillRate: 'Overfill Ratio',
    expectedDate: 'Expected Arrival Time',
    remark: 'Remarks',
    logisticsBusinessName: 'Logistics Company',
    logisticsNo: 'Waybill Number',
    logisticsAmount: 'Shipping cost',
    recipientName: 'Full Name',
    phone: 'Mobile',
    shippingAddress: 'Delivery Address',
    sourceCode: 'Source Order No.',
    thirdCode: 'External Document Number',
    productInformation: 'Product Information',
    notice: 'Notification',
    result: 'Result',
    purchaseOrder: 'Purchase Order',
    log: 'Log',

    table: {
      spuPic: 'Product Image',
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      skuName: 'SKU Name',
      planQty: 'Purchase Quantity',
      alreadyQty: 'Received Quantity',
      waitQty: 'Unreceived Quantity',
      cancelQty: 'Stop Waiting Quantity',
      taxUnitPrice: 'Tax-Inclusive Order Price',
      taxRate: 'Tax Rate',
      taxPrice: 'Tax-Inclusive Amount',
      supplierSpuCode: 'Supplier Product Code',
      supplierSkuCode: 'Supplier SKU Code',
      remark: 'Product Remarks',
      meaning: 'Associated documents',
      typeMeaning: 'Associated Document Type',
      associatedCode: 'Ref. No.',
      associatedStatusMeaning: 'Document Status',
    }
  }
};
